<template>
  <div class="wizard-step-content wizard-step-projection">
    <ul class="wizard-step-content__group-list u-reset">
      <li class="wizard-step-content__group wizard-step-projection__type-select">
        <h2 class="u-reset wizard-step-content__sub-title">
          {{ $t('wizard_step.projection.type_select_title') }}
        </h2>

        <projection-selector
          :facets="['projection-type-list']"
          :options="$options.projectionTypeList"
          :selection-mode-id="$options.selectionModeIds.PROJECTION_TYPE"
          :show-label="true"
          :value.sync="activeProjectionTypeId"
        />
      </li>
      <li class="wizard-step-content__group wizard-step-projection__shape-select">
        <h2 class="u-reset wizard-step-content__sub-title">
          {{ $t('wizard_step.projection.shape_select_title') }}
        </h2>

        <projection-selector
          :available-options="availableProjectionShapeList"
          :facets="['projection-shape-list']"
          :options="$options.projectionShapeList"
          :selection-mode-id="$options.selectionModeIds.PROJECTION_SHAPE"
          :value.sync="activeProjectionShapeId"
        />
      </li>
      <li class="wizard-step-content__group wizard-step-projection__projection-list">
        <h2 class="u-reset wizard-step-content__sub-title">
          {{ $t('wizard_step.projection.projection_list_title') }}
        </h2>

        <projection-selector
          :facets="['projection-list']"
          :options="filteredProjectionList"
          :selection-mode-id="$options.selectionModeIds.PROJECTION"
          :show-label="true"
          :value.sync="activeProjectionId"
        />
      </li>
    </ul>
  </div>
</template>

<script>
  import { mapActions } from 'vuex'
  import {
    projectionList,
    projectionShapeList,
    projectionTypeList,
  } from '@/assets/js/model/projection'
  import { selectionModeIds } from '@/components/projection-selector/selection-mode'
  import ProjectionSelector from '@/components/projection-selector/projection-selector'

  const EXCLUDED_PROJECTION_IDS = []

  export default {
    components: { ProjectionSelector },
    props: {
      mapConfig: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        activeProjectionTypeId: '',
        activeProjectionShapeId: '',
      }
    },
    computed: {
      activeProjectionId: {
        get() {
          return this.mapConfig.projectionId
        },
        set(projectionId) {
          this.setMapConfig({
            ...this.mapConfig,
            projectionId,
          })
        },
      },
      validProjectionList() {
        return this.$options.projectionList.filter(({ id }) => {
          return !EXCLUDED_PROJECTION_IDS.includes(id)
        })
      },
      filteredProjectionList() {
        return this.validProjectionList
          .filter(({ projectionTypeId }) => {
            const hasIncludedType = this.activeProjectionTypeId === projectionTypeId
            return hasIncludedType || !this.activeProjectionTypeId
          })
          .filter(({ projectionShapeId }) => {
            const hasIncludedShape = this.activeProjectionShapeId === projectionShapeId
            return hasIncludedShape || !this.activeProjectionShapeId
          })
      },
      availableProjectionShapeList() {
        const activeProjections = this.validProjectionList.filter(({ projectionTypeId }) => {
          const hasIncludedType = this.activeProjectionTypeId === projectionTypeId
          return hasIncludedType || !this.activeProjectionTypeId
        })

        return this.$options.projectionShapeList.filter(({ id }) => {
          return activeProjections.some(({ projectionShapeId }) => projectionShapeId === id)
        })
      },
    },
    watch: {
      activeProjectionTypeId() {
        const isIncluded = this.availableProjectionShapeList
          .map(({ id }) => id)
          .includes(this.activeProjectionShapeId)

        if (!isIncluded) {
          this.activeProjectionShapeId = ''
        }

        if (this.availableProjectionShapeList.length === 1) {
          this.activeProjectionShapeId = this.availableProjectionShapeList[0].id
        }

        this.selectValidProjection()
      },
      activeProjectionShapeId() {
        this.selectValidProjection()
      },
    },
    methods: {
      ...mapActions('world-map', ['setMapConfig']),
      selectValidProjection() {
        const isIncludedInActiveProjections = this.filteredProjectionList
          .map(({ id }) => id)
          .includes(this.activeProjectionId)

        if (!isIncludedInActiveProjections) {
          this.activeProjectionId = this.filteredProjectionList[0].id
        }
      },
    },
    projectionList,
    projectionTypeList,
    projectionShapeList,
    selectionModeIds,
  }
</script>

<style lang="scss" src="./_wizard-step-projection.scss" />
